import { useCallback, useState } from 'react';
import { validateBitcoinAddress } from '../lib/btcAddress';
import {
  getTrackedAddress,
  setTrackedAddress,
  type TrackedAddress,
} from '../lib/storage';

export function useTrackedAddress() {
  const [tracked, setTracked] = useState<TrackedAddress>(() => getTrackedAddress());

  const updateAddress = useCallback(
    (address: string, label: string): { ok: boolean; reason?: string } => {
      const trimmed = address.trim();
      const validation = validateBitcoinAddress(trimmed);
      if (!validation.valid) {
        return {
          ok: false,
          reason: validation.reason ?? 'Enter a valid Bitcoin mainnet address.',
        };
      }
      const next: TrackedAddress = {
        address: trimmed,
        label: label.trim().length > 0 ? label.trim() : 'Wallet',
      };
      setTrackedAddress(next);
      setTracked(next);
      return { ok: true };
    },
    [],
  );

  return { tracked, updateAddress };
}
